import React from 'react';
import BrandMark from './BrandMark';
import { BRAND } from '../../utils/brand';

function BrandLockup({ title, subtitle = BRAND.name, size = 'md' }) {
  const isSmall = size === 'sm';

  return (
    <div className="flex items-center gap-3">
      <BrandMark size={size} />
      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400">
          {subtitle}
        </p>
        {title && (
          <h1 className={`${isSmall ? 'text-sm leading-tight' : 'text-2xl'} font-bold text-gray-900 dark:text-neutral-100`}>
            {title}
          </h1>
        )}
      </div>
    </div>
  );
}

export default BrandLockup;
